<div class="h-1 border-b border-gray-200" *ngIf="!showSelectedItems">
    <mat-progress-bar *ngIf="!loaded" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex items-center py-4 pl-2 border-b" *ngIf="showSelectedItems">
    <button class="mr-1" mat-icon-button (click)="hideSelectedItemsPanel()">
        <em class="ti ti-arrow-narrow-left icon-size-7 text-gray-500"></em>
    </button>
    <div class="ml-1 flex items-center">
        <span class="text-lg">{{'dataPicker.asset.selected_assets' | translate}}</span>
        <badge class="ml-2"
            [options]="getBadgeOptions('PRIMARY', selectedAssets ? selectedAssets.length : 0, null, 'listingCount')">
        </badge>
    </div>
</div>
@if(assets?.length > 0){
    <div class="overflow-y-auto zuper-scrollbar data-picker-list-content-height">
        @if(associatedAssets?.length > 0 && isFromNote){
            <div class="flex justify-between items-center" [ngClass]="{'border-b border-gray-200': !isAssociatedExpanded}">
                <div class="text-base primary-font font-normal text-gray-500 py-3 px-5">
                    @if(associatedAssets.length > 1){
                        {{'text.assets' | translate}}
                    } @else{
                        {{'asset.text' | translate}}
                    }
                    {{ notesPickerPreferences[module].label | translate}}
                </div>
                <div class="relative cursor-pointer py-3 px-5 flex items-center space-x-2 text-gray-700 transition-all"
                    (click)="isAssociatedExpanded = !isAssociatedExpanded"
                    [ngClass]="{ 'custom-expanded-top': isAssociatedExpanded }">
                    <div class="flex flex-col items-center text-blue-500">
                        <ng-container *ngIf="!isAssociatedExpanded">
                            <i class="text-base font-medium leading-6 ti ti-chevron-up rotate-180"></i>
                            <i class="-mt-3 text-base font-medium leading-6 ti ti-chevron-down rotate-180"></i>
                        </ng-container>
                        <ng-container *ngIf="isAssociatedExpanded">
                            <i class="text-base font-medium leading-6 ti ti-chevron-up"></i>
                            <i class="-mt-3 text-base leading-6 font-medium ti ti-chevron-down"></i>
                        </ng-container>
                    </div>
                    <span class="text-base font-medium text-blue-500">
                        {{ isAssociatedExpanded ? ('collapse' | translate) : ('expand' | translate) }}
                    </span>
                </div>
            </div>
            @if(isAssociatedExpanded){
                <ul role="list"  class="border-b border-gray-200">
                    <li class="asset-data-picker-list-ele border-b border-gray-200" *ngFor="let asset of associatedAssets;let index = index">
                        <ng-container *ngTemplateOutlet="assetTemplate; context: { asset: asset || asset,index: index,isAssociated: true }"></ng-container>
                    </li>
                </ul>
            }
            <div class="text-base primary-font font-normal text-gray-500 py-3 px-5">
                {{'text.picker.association.all.assets' | translate}}
            </div>
        }
        @if(notesPickerPreferences[module]?.preference?.asset === 'LINKED' && isFromNote){
            <div class="text-base primary-font font-normal text-gray-500 py-3 px-5">
                @if(assets.length > 0){
                    {{'text.assets' | translate}}
                } @else{
                    {{'asset.text' | translate}}
                }
                {{ notesPickerPreferences[module].label | translate}}
            </div>
        }
        <ul role="list" class="divide-y divide-gray-200 " [ngClass]="{ 'data-picker-max-count': isMaxSelectionLimit }"
            *ngIf="assets.length">
            <li class="asset-data-picker-list-ele" *ngFor="let asset of assets;let index = index">
                <ng-container *ngTemplateOutlet="assetTemplate; context: { asset: asset,index: index,isAssociated: false }"></ng-container>
            </li>
        </ul>
    </div>
}

<div class="overflow-hidden data-picker-list-content-height flex flex-col items-center justify-center"
    *ngIf="!assets.length && loaded && !showSelectedItems">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_assets_found.svg" alt="No Assets Found">
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="onSearch">{{'dataPicker.asset.not_found' | translate}}
            '{{searchKey}}'</h4>
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="!onSearch">{{'dataPicker.asset.placeholder' | translate}}
        </h4>
    </div>
</div>

<ng-template #assetTemplate let-asset="asset" let-index="index" let-isAssociated="isAssociated">
    <div class="hover:bg-gray-50 group relative flex items-center p-4"
    [ngClass]="{'cursor-pointer': selectOption === 'readOnly'}"
    (click)="selectOption === 'readOnly' ? viewAssetDetails($event, asset.asset_uid) : null">
    <a class="-m-1 block flex-1 p-1 picker-data-parent-container">
        <div class="relative flex min-w-0 flex-1 items-center">
            <div class="picker-data-inner-container flex" *ngIf="selectOption === 'multiSelect'">
                <span class="flex items-center justify-center px-1">
                    <input 
                        type="checkbox" 
                        class="picker-data-selection-size" 
                        [id]="isAssociated ? 'asset_data_select_associated_' + index : 'asset_data_select_' + index"
                        (change)="selectAsset($event, asset)" 
                        [checked]="isSelectedAsset(asset)"
                        [disabled]="validateSelectionDisable(asset)"
                        [matTooltip]="validateSelectionDisable(asset) ? ('dataPicker.asset.selection_disable.text' | translate) : null" />
                </span>
                <div class="ml-4 truncate picker-data-value-content">
                    <ng-container *ngTemplateOutlet="assetsContent"></ng-container>
                </div>
            </div>
            <div class="picker-data-inner-container flex" *ngIf="selectOption === 'select'">
                <span class="flex items-center justify-center px-1">
                    <input 
                        type="radio" 
                        class="picker-data-selection-size" 
                        [id]="isAssociated ? 'asset_data_select_associated_' + index : 'asset_data_select_' + index"
                        (change)="selectAsset($event, asset)" 
                        [checked]="isSelectedAsset(asset)" 
                        [disabled]="validateSelectionDisable(asset)" [matTooltip]="validateSelectionDisable(asset) ? ('dataPicker.asset.selection_disable.text' | translate) : null"/>
                </span>
                <div class="ml-4 truncate picker-data-value-content">
                    <ng-container *ngTemplateOutlet="assetsContent"></ng-container>
                </div>
            </div>
            <ng-container *ngIf="selectOption === 'readOnly'">
                <div class="ml-2 truncate picker-data-value-content">
                    <ng-container *ngTemplateOutlet="assetsContent"></ng-container>
                </div>
            </ng-container>
            <ng-template #assetsContent>
                <div class="w-full flex items-center justify-between">
                    <div class="flex flex-col flex-1 min-w-0">
                        <div class="flex items-center min-w-0">
                            <label class="truncate text-lg font-medium text-gray-900 cursor-pointer" 
                                   [for]="isAssociated ? 'asset_data_select_associated_' + index : 'asset_data_select_' + index"
                                   matTooltip="{{asset?.asset_code}} - {{asset?.asset_name}}">
                                {{asset?.asset_code}} - {{asset?.asset_name}}
                            </label>
                        </div>
                        <label *ngIf="asset?.asset_serial_number?.length" [matTooltip]="('text.serial_number' | translate)"
                               class="flex mt-1 truncate text-base text-gray-500">
                               <em class="ti ti-barcode mr-1 icon-size-4"></em>
                               <span
                                   class="truncate text-base text-gray-500">
                               {{utilityService.getAssetSerialNumber(asset?.asset_serial_number)}} </span>
                        </label>
                    </div>
                    <div class="flex-shrink-0 ml-4 self-center">
                        <badge *ngIf="asset?.asset_status"  [options]="getBadgeOptions(asset?.asset_status, (getAssetStatusValue(asset?.asset_status) | titlecase))"></badge>
                    </div>
                </div>
            </ng-template>
            <button mat-icon-button class="cursor-pointer ml-auto"
                matTooltip="{{ updateArrowTooltipText(asset?.asset_uid, isAssociated) | translate }}" matTooltipPosition="left"
                *ngIf="!showSpinLoading(asset?.asset_uid, isAssociated)" [ngClass]="rotateArrowIcon(asset?.asset_uid, isAssociated)"
                (click)="viewAssetDetails($event, asset?.asset_uid, isAssociated)">
                <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                    data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down"
                        width="24" height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor"
                        fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none">
                        </path>
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </mat-icon>
            </button>
            <div class="ml-auto py-2.5 h-10" *ngIf="showSpinLoading(asset?.asset_uid, isAssociated)">
                <mat-spinner class="ml-auto data-picker-spinner md:mr-3" [diameter]="18" style="width: 18px;height: 18px"></mat-spinner>
            </div>
        </div>
    </a>
</div>
<div class="p-4 bg-gray-100"
    *ngIf="(('asset_details_' + asset?.asset_uid === assetEleId && !isAssociated) || ('asset_details_associated_' + asset?.asset_uid === assetEleId && isAssociated)) && assetDetails && !isSpinLoading">
    <div class="bg-card rounded relative">
        <a target="_blank" class="hidden" #viewFullDetails href="{{viewAssetFullDetails(asset?.asset_uid)}}"></a>
        <span class="cursor-pointer absolute right-0 pt-1 pr-1 z-50" (click)="viewFullDetails.click($event)"
            matTooltip="{{'text.view_details.new_tab' | translate}}" matTooltipPosition="left">
            <button mat-icon-button>
                <mat-icon class="text-xl">open_in_new</mat-icon>
            </button>
        </span>
        <div class="text-base">
            <div class="px-2 truncate flex flex-wrap">
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.customer">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'dataPicker.asset.content.associated_customer' | translate}}</p>
                    <p class="mt-1 text-gray-900"
                        *ngIf="assetDetails.customer.is_deleted === true || !utilityService.hasModuleAccess('CUSTOMER')">
                        {{(assetDetails.customer.customer_first_name)}}
                        {{(assetDetails.customer.customer_last_name ?? '')}}</p>
                    <p class="mt-1">
                        <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                            [routerLink]="utilityService.getLink('CUSTOMER', assetDetails.customer.customer_uid)"
                            *ngIf="!assetDetails.customer.is_deleted && utilityService.hasModuleAccess('CUSTOMER')">
                            {{(assetDetails.customer.customer_first_name)}}
                            {{(assetDetails.customer.customer_last_name ?? '')}}</a>
                    </p>
                </div>
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.organization">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.organization_name' | translate}}</p>
                    <p class="mt-1 text-gray-900"
                        *ngIf="assetDetails.organization.is_deleted === true || !utilityService.hasModuleAccess('ORGANIZATION')">
                        {{(assetDetails.organization.organization_name)}}</p>
                    <p class="mt-1">
                        <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                            [routerLink]="utilityService.getLink('ORGANIZATION', assetDetails.organization.organization_uid)"
                            *ngIf="!assetDetails.organization.is_deleted && utilityService.hasModuleAccess('ORGANIZATION')">
                            {{(assetDetails.organization.organization_name)}}</a>
                    </p>
                </div>
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.asset_category">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.asset_category' | translate}}</p>
                    <p class="mt-1 text-gray-900">
                        {{assetDetails.asset_category.category_name}}</p>
                </div>
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.property">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'dataPicker.asset.content.asset_property' | translate}}</p>
                    <p class="mt-1 text-gray-900"
                        *ngIf="assetDetails.property.is_deleted === true || !utilityService.hasModuleAccess('PROPERTY')">
                        {{assetDetails.property.property_name ?? ''}}</p>
                    <p class="mt-1">
                        <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                            [routerLink]="utilityService.getLink('PROPERTY', assetDetails.property.property_uid)"
                            *ngIf="!assetDetails.property.is_deleted && utilityService.hasModuleAccess('PROPERTY')">
                            {{assetDetails.property.property_name ?? ''}}</a>
                    </p>
                </div>
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.asset_product">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.asset_product' | translate}}</p>
                    <p class="mt-1 text-gray-900"
                        *ngIf="assetDetails.asset_product.is_deleted === true || !utilityService.hasModuleAccess('PRODUCTS')">
                        {{assetDetails.asset_product.product_name}}</p>
                    <p class="mt-1">
                        <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                            [routerLink]="utilityService.getLink('PRODUCTS', assetDetails.asset_product.product_uid)"
                            *ngIf="!assetDetails.asset_product.is_deleted && utilityService.hasModuleAccess('PRODUCTS')">
                            {{assetDetails.asset_product.product_name}}</a>
                    </p>
                </div>
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.parent_asset">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.parent_asset' | translate}}</p>
                    <p class="mt-1 text-gray-900"
                        *ngIf="assetDetails.parent_asset.is_deleted === true || !utilityService.hasModuleAccess('ASSETS')">
                        {{assetDetails.parent_asset.asset_name}}</p>
                    <p class="mt-1">
                        <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                            [routerLink]="utilityService.getLink('ASSETS', assetDetails.parent_asset.asset_uid)"
                            *ngIf="!assetDetails.parent_asset.is_deleted && utilityService.hasModuleAccess('ASSETS')">
                            {{assetDetails.parent_asset.asset_name}}</a>
                    </p>
                </div>
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.asset_inspection_form">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.asset_inspection_form' | translate}}</p>
                    <p class="mt-1 text-gray-900">
                        {{assetDetails.asset_inspection_form?.asset_form_name}}</p>
                </div>
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.purchase_date">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.purchase_date' | translate}}</p>
                    <p class="mt-1 text-gray-900">
                        {{assetDetails.purchase_date | dateformat}}</p>
                </div>
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.purchase_price">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.purchase_price' | translate}}</p>
                    <p class="mt-1 text-gray-900">
                        {{currency + ' ' + (assetDetails.purchase_price | number:
                        digitsInfo)}}</p>
                </div>
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.placed_in_service">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.placed_in_service' | translate}}</p>
                    <p class="mt-1 text-gray-900">
                        {{assetDetails.placed_in_service | dateformat}}</p>
                </div>
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.warranty_expiry_date">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.warranty_date' | translate}}</p>
                    <p class="mt-1 text-gray-900">
                        {{assetDetails.warranty_expiry_date | dateformat}}</p>
                </div>
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.last_service_date">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.last_service_date' | translate}}</p>
                    <p class="mt-1 text-gray-900">
                        {{assetDetails.last_service_date | dateformat}}</p>
                </div>
                <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                    *ngIf="assetDetails.next_service_date">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'text.next_service_date' | translate}}</p>
                    <p class="mt-1 text-gray-900">
                        {{assetDetails.next_service_date | dateformat}}</p>
                </div>
            </div>
        </div>
        <div class="px-2 py-2 border-t text-base"
            *ngIf="assetDetails.asset_location?.street || assetDetails.asset_location?.state">
            <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                {{'text.asset_location' | translate}} </p>
            <div class="px-3">
                <p *ngIf="assetDetails.asset_location.first_name" class="text-base mb-2">
                    {{assetDetails.asset_location.first_name}}
                    {{assetDetails.asset_location.last_name ?? ''}}</p>
                <p *ngIf="assetDetails.asset_location.street" class="text-base mb-2">
                    {{assetDetails.asset_location.street}}</p>
                <p *ngIf="assetDetails.asset_location.landmark" class="text-base mb-2">
                    {{assetDetails.asset_location.landmark}}</p>
                <p *ngIf="assetDetails.asset_location.city" class="text-base mb-2">
                    {{assetDetails.asset_location.city}}</p>
                <p *ngIf="assetDetails.asset_location.state" class="text-base mb-2">
                    {{assetDetails.asset_location.state}}
                    {{assetDetails.asset_location.zip_code ? '- ' +
                    assetDetails.asset_location.zip_code : '' }}</p>
                <p *ngIf="assetDetails.asset_location.country" class="text-base">
                    {{assetDetails.asset_location.country}}</p>
            </div>
        </div>
        <div class="px-2 py-2 border-t text-base"
            *ngIf="assetDetails.billing_address?.street || assetDetails.billing_address?.state">
            <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                {{'billing.address.text' | translate}} </p>
            <div class="px-3">
                <p *ngIf="assetDetails.billing_address.first_name" class="text-base mb-2">
                    {{assetDetails.billing_address.first_name}}
                    {{assetDetails.billing_address.last_name ?? ''}}</p>
                <p *ngIf="assetDetails.billing_address.street" class="text-base mb-2">
                    {{assetDetails.billing_address.street}}</p>
                <p *ngIf="assetDetails.billing_address.landmark" class="text-base mb-2">
                    {{assetDetails.billing_address.landmark}}</p>
                <p *ngIf="assetDetails.billing_address.city" class="text-base mb-2">
                    {{assetDetails.billing_address.city}}</p>
                <p *ngIf="assetDetails.billing_address.state" class="text-base mb-2">
                    {{assetDetails.billing_address.state}}
                    {{assetDetails.billing_address.zip_code ? '- ' +
                    assetDetails.billing_address.zip_code : '' }}</p>
                <p *ngIf="assetDetails.billing_address.country" class="text-base">
                    {{assetDetails.billing_address.country}}</p>
            </div>
        </div>
    </div>
</div>
</ng-template>